import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Field from '../../../../components/Form/Field'
import Button from '../../../../components/Button'

import { NAME } from '../fields'

import useStyles from '../../../../styles/common/stepForms'

const stepFields = [NAME]

function NameStep({ formik, handleStepChange }) {
  const commonClasses = useStyles()

  const { t } = useTranslation()

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('Give the new ad a name')}</div>
      <div className={commonClasses.stepBody}>
        <Field formik={formik} name={NAME} placeholder="Name" autoComplete="off" />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default NameStep
